export default __webpack_public_path__ + "static/media/filter.0ba9c0f5.svg";